// import './GlobalVariable';

import { LOGIN_COOKIE_NAME, APP_TYPE_COOKIE_NAME, LOGIN_SESSION_NAME, USER_TYPE_COOKIE_NAME , LOGIN_COOKIE_NAME_SPLITBY} from "./CommonVariable";

export function setLoggedOut(store) {
    // const store = useContext(GLOBAL_CONTEXT);
    document.cookie = LOGIN_COOKIE_NAME + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; samesite=lax;";
    document.cookie = APP_TYPE_COOKIE_NAME + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; samesite=lax;";
    document.cookie = LOGIN_SESSION_NAME + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; samesite=lax;";
    document.cookie = USER_TYPE_COOKIE_NAME + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; samesite=lax;";
    store.setLogin('out');
}

export function handleTrackingModal(store, value) {
    store.setTrackingModal(value);
}

export function handleCommonData(store, value) {
    store.data = value;
}

export function setLoggedIn(store) {
    // const store = useContext(GLOBAL_CONTEXT);
    store.setLogin('in');
}

export function handleLogOut(store) {
    handleCommonData(store, []);
    handleTrackingModal(store, false);
    setLoggedOut(store);
}

export function setUserCookie(USER_COOKIE_NAME, cookie, time) {
    document.cookie = USER_COOKIE_NAME + "=" + cookie + ";path=/;max-age=" + time + "; samesite=lax;";
}

export function setWebsiteCookie(name, value, time) {
    value = value ?? '';
    document.cookie = name + "=" + value + ";path=/;max-age=" + time + "; samesite=lax;";
}

export function setSessionCookie(name, value, time) {
    value = value ?? '';
    document.cookie = name + "=" + value + ";path=/;max-age=" + time + "; samesite=lax;";
}

export function setUserTypeCookie(name, value, time) {
    value = value ?? '';
    document.cookie = name + "=" + value + ";path=/;max-age=" + time + "; samesite=lax;";
}

export function setPageCookie(name, value, time) {
    value = value ?? '';
    document.cookie = name + "=" + value + ";path=/;max-age=" + time + "; samesite=lax;";
}

export function setLoginCookie(LOGIN_COOKIE_NAME, loginId, clientCode, clientName, brnCode, time) {
    document.cookie = LOGIN_COOKIE_NAME + "=" + loginId + LOGIN_COOKIE_NAME_SPLITBY + clientCode + LOGIN_COOKIE_NAME_SPLITBY + clientName + LOGIN_COOKIE_NAME_SPLITBY + brnCode + ";path=/;max-age=" + time + "; samesite=lax;";
}

export function setAppTypeCookie(cookieName, applicationType, time) {
    document.cookie = cookieName + "=" + applicationType + ";path=/;max-age=" + time + "; samesite=lax;";
}

export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export const throttle = (fn, limit) => {
    let flag = true;
    return function () {
        let context = this;
        let args = arguments;
        if (flag) {
            fn.apply(context, args);
            flag = false;
            setTimeout(() => {
                flag = true;
            }, limit);
        }
    }
}

export function appendArray(arr1, arr2) {
    const l1 = arr1.length;
    const l2 = arr2.length;
    let i;
    for (i = 0; i < l2; i++) {
        arr1[l1 + i] = arr2[i];
    }
    return arr1;
}

// get current financial year------------
export function getCurrentFinancialYear() {
    let fiscalyear = "";
    let today = new Date();
    if ((today.getMonth() + 1) <= 3) {
        fiscalyear = (today.getFullYear() - 1) + "-" + today.getFullYear()
    } else {
        fiscalyear = today.getFullYear() + "-" + (today.getFullYear() + 1)
    }
    return fiscalyear
}

export function formatDate(dateString, dateFormat = 'dd-MM-yyyy') {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with zero if needed
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-indexed, so add 1) and pad with zero
    const year = date.getFullYear(); // Get full year
    if ('dd-MM-yyyy' === dateFormat) {
        return `${day}-${month}-${year}`; // Return formatted date
    }
    return `${day}-${month}-${year}`; // Return formatted date
};

export function convertToTwoDecimelNumber(num) {
    // Check if num is undefined, null, or any other unwanted values
    if (num === undefined || num === null || num === '' || num === 0) {
        return; // Exit the function if any of these conditions are met
    }

    // Convert to string and split at the decimal point
    const parts = num.toString().split('.');

    // If there's no decimal part, return the integer part
    if (parts.length === 1) {
        return parts[0];
    } else {
        // Get the integer part and the first two decimal places
        const integerPart = parts[0];
        const decimalPart = parts[1].substring(0, 2); // Get first two digits of the decimal part
        return `${integerPart}${decimalPart ? '.' + decimalPart : ''}`; // Combine
    }
}

export const simulateAsyncOperation = (duration) => {
    return new Promise((resolve) => {
        setTimeout(resolve, duration);
    });
};

export const clearMasterData=(masterData)=>{
    masterData.setLIST_CLIENT([]);
    masterData.setLIST_CLIENTVAS([]);
    masterData.setLIST_SERVICE([]);
    masterData.setLIST_NETWORK([]);
    masterData.setLIST_CITY([]);
    masterData.setLIST_COUNTRY([]);
    masterData.setLIST_PINCODE([])
    masterData.setLIST_STATE([])
    masterData.setList_loadRateForAutoCalculation([]);
    masterData.setList_loadRateForLogistic([])
    masterData.setORIGINAL_ZONECODE('')
    masterData.setZONECODE_MAPPED_WITHCITY('')
    masterData.setWEIGHT_TYPE('')
    masterData.setWEIGHT_SLAB(0)
    masterData.setLIST_TATDAYS([])
    masterData.setLIST_CLIENTSERIESATE([])
    console.log("cleared");
}